export enum TTXAssistantResponseFormat {
  JSON_OBJECT = 'json_object',
  TEXT = 'text',
}

export enum TTXAssistantStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum TTXAssistantModel {
  GPT_4O = 'gpt-4o',
  GPT_4O_MINI = 'gpt-4o-mini',
  GPT_4_TURBO = 'gpt-4-turbo',
  GPT_4 = 'gpt-4',
}
export interface TTXCreateAssistantBody {
  name: string;
  instructions: string;
  model: TTXAssistantModel;
  temperature: number;
  topP: number;
  status: TTXAssistantStatus;
  files?: any[];
}

export interface TTXAssistant extends TTXCreateAssistantBody {
  _id: string;
  assistantId?: string;
  vectorStoreId?: string;
  localVectorStoreId?: string;
}

export type TTXUpdateAssistantBody = Partial<TTXCreateAssistantBody>;
